import { useState } from "react";
import { eng } from "@/lib/engineApi";
import { useGrid } from "@/state/grid";
import { joinDemoProject } from "@/lib/auth";
import { LOGO_DATA_URI } from "@/assets/logo";

/** In-app role selection — faithful React port of the engine's loginScreen(). */
export default function RolePicker() {
  const e = eng();
  const D = e.D;
  const enter = useGrid((s) => s.enter);
  const [sel, setSel] = useState<string>(e.currentRole || "inspector");

  return (
    <div className="login-overlay">
      <div className="login-box">
        <div className="login-logo">
          <div className="login-glyph">
            <img src={LOGO_DATA_URI} alt="TerraTrace logo" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </div>
          <div>
            <div className="login-brand serif">GridProof</div>
            <div className="login-sub">powered by TerraTrace</div>
          </div>
        </div>
        <div className="login-project">
          {D.project.name} · {D.project.location}
        </div>
        <div className="login-operator">
          Operator · <b>Catalin Radu</b>
        </div>
        <div className="login-label">Select your role to continue</div>
        <div className="login-roles">
          {Object.entries(D.roles).map(([rid, r]) => (
            <button
              key={rid}
              className={`role-card ${sel === rid ? "sel" : ""}`}
              style={{ ["--rc" as any]: (r as any).color }}
              onClick={() => setSel(rid)}
            >
              <div className="rc-label" style={{ color: (r as any).color }}>
                {(r as any).label}
              </div>
              <div className="rc-desc">{(r as any).desc}</div>
              <div className="rc-access">
                {(r as any).canEdit ? <span className="rca">Edit</span> : null}
                {(r as any).canApprove ? <span className="rca">Approve</span> : null}
                {(r as any).tddAccess ? <span className="rca">TDD</span> : null}
                {!(r as any).canEdit && !(r as any).canApprove ? <span className="rca ro">Read-only</span> : null}
              </div>
            </button>
          ))}
        </div>
        <button
          className="login-enter"
          onClick={() => {
            joinDemoProject(sel);
            enter(sel);
          }}
        >
          Enter platform →
        </button>
        <div className="login-note">
          All inspection data syncs to this project. Use the gear menu (top right) to save or load data snapshots.
        </div>
      </div>
    </div>
  );
}
